/*
 * @Author: youfanrong 737064439@qq.com
 * @Date: 2025-03-03 08:59:07
 * @LastEditors: youfanrong 737064439@qq.com
 * @LastEditTime: 2025-09-29 16:27:39
 * @FilePath: /bar-front-end/src/main.ts
 */
import 'vue/jsx'

// 引入windi css
import '@/plugins/unocss'

// 导入全局的svg图标
import '@/plugins/svgIcon'

// 初始化多语言
import { setupI18n } from '@/plugins/vueI18n'

// 引入状态管理
import { setupStore } from '@/store'

// 全局组件
import { setupGlobCom } from '@/components'

// 引入element-plus
import { setupElementPlus } from '@/plugins/elementPlus'

// 引入全局样式
import '@/styles/index.less'

// 引入动画
import '@/plugins/animate.css'

// 路由
import { setupRouter } from './router'
import router from './router'

// 权限
import { setupPermission } from './directives'

import { createApp } from 'vue'

import App from './App.vue'

import './permission'

// Element Plus 图标全量注册会显著增加打包体积，建议按需引入或通过 Icon 组件使用
// import * as ElementPlusIconsVue from '@element-plus/icons-vue'
// for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
//   app.component(key, component)
// }

// 导入版本检查功能
import { initVersionCheck, startVersionCheck, enableVisibilityCheck } from '@/utils/versionCheck'

import { useUserStoreWithOut } from '@/store/modules/user'
import * as Sentry from "@sentry/vue";

// 创建实例
const setupAll = async () => {
  const app = createApp(App)

  Sentry.init({
    app,
    dsn: "https://0206a347711620bf8794db04be9683ac@o4510697751314432.ingest.us.sentry.io/4510697753083904",
    // 自动通过 import.meta.env.VITE_NODE_ENV 区分环境（test, production 等）
    environment: import.meta.env.VITE_NODE_ENV,
    integrations: [
      Sentry.browserTracingIntegration({
        router: router
      }),
    ],
    // 性能采样率，开发环境可以设为 1.0，生产环境建议降低
    tracesSampleRate: 1.0,
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true
  });

  // 监控静态资源（JS, CSS, Image）加载耗时，识别 Pending 很久的情况
  if (window.PerformanceObserver) {
    const observer = new PerformanceObserver((list) => {
      list.getEntries().forEach((entry: any) => {
        // 如果资源加载超过 8 秒（Pending 很久）
        if (entry.duration > 8000) {
          const userStore = useUserStoreWithOut()
          const userInfo = userStore.getUserInfo as any
          const token = userStore.getToken
          
          Sentry.captureMessage(`资源加载过慢 (${Math.round(entry.duration)}ms): ${entry.name}`, {
            level: 'warning',
            tags: {
              type: 'slow_resource',
              initiatorType: entry.initiatorType,
              user_name: userInfo?.username || 'unknown',
              user_id: userInfo?.id || 'unknown'
            },
            extra: {
              duration: entry.duration, // 资源加载耗时
              transferSize: entry.transferSize, // 资源传输大小
              btk: token // 用户 token
            }
          });
        }
      });
    });
    observer.observe({ type: 'resource', buffered: true });
  }

  // 捕获资源加载错误（如图片、脚本、样式表 404）
  window.addEventListener(
    'error',
    (event: ErrorEvent) => {
      // 过滤 JS 执行错误，这类错误 Sentry 默认会自动捕获
      // 资源加载错误通常没有 message 属性
      if ((event as any).message || (event as any).error) return

      const target = event.target || (event as any).srcElement
      const isElementTarget =
        target instanceof HTMLImageElement ||
        target instanceof HTMLScriptElement ||
        target instanceof HTMLLinkElement

      if (!isElementTarget) return

      const url = (target as any).src || (target as any).href
      Sentry.captureMessage(`资源加载失败: ${url}`, {
        level: 'error',
        tags: {
          type: 'resource_error',
          tagName: (target as HTMLElement).tagName
        },
        extra: {
          outerHTML: (target as HTMLElement).outerHTML
        }
      })
    },
    true // 核心：使用捕获阶段，因为资源加载错误不会冒泡
  );

  await setupI18n(app)

  setupStore(app)

  setupGlobCom(app)

  setupElementPlus(app)

  setupRouter(app)

  setupPermission(app)

  app.mount('#app')
  
  // 应用挂载完成后启动版本检查
  setTimeout(async () => {
    try {
      // 初始化版本信息
      await initVersionCheck()
      
      // 启动定期版本检查（5分钟检查一次，使用模态框提示）
      startVersionCheck({
        interval: 3 * 60 * 1000, // 5分钟
        mode: 'modal', // 使用模态框提示
        autoStart: true
      })
      
      // 启用页面可见性检查
      enableVisibilityCheck()
      
      console.log('版本检查功能已启动')
    } catch (error) {
      console.warn('启动版本检查失败:', error)
    }
  }, 10000) // 延迟10秒启动，确保应用完全加载
}

setupAll()
